import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "progress", "nextButton", "backButton", "submitButton"]
  static values = { currentStep: { type: Number, default: 1 } }

  connect() {
    this.showStep()
  }

  next(event) {
    if (event) event.preventDefault()
    
    if (this.validateCurrentStep()) {
      this.currentStepValue++
      this.showStep()
    }
  }

  back(event) {
    if (event) event.preventDefault()
    this.currentStepValue--
    this.showStep()
  }

  showStep() {
    this.stepTargets.forEach((element, index) => {
      element.classList.toggle("hidden", index + 1 !== this.currentStepValue)
    })

    if (this.hasProgressTarget) {
      this.progressTargets.forEach((element, index) => {
        const stepIndex = index + 1
        element.classList.toggle("bg-primary", stepIndex <= this.currentStepValue)
        element.classList.toggle("bg-gray-200", stepIndex > this.currentStepValue)
      })
    }

    if (this.hasBackButtonTarget) {
      this.backButtonTarget.classList.toggle("hidden", this.currentStepValue === 1)
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.classList.toggle("hidden", this.currentStepValue === this.stepTargets.length)
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.classList.toggle("hidden", this.currentStepValue !== this.stepTargets.length)
    }

    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  validateCurrentStep() {
    const currentStepElement = this.stepTargets[this.currentStepValue - 1]
    const requiredInputs = currentStepElement.querySelectorAll("[required]")
    let isValid = true

    requiredInputs.forEach(input => {
      if (!input.value.trim()) {
        isValid = false
        input.classList.add("border-red-500")
        
        // Add error message if not present
        if (!input.nextElementSibling?.classList.contains("wizard-error")) {
          const error = document.createElement("p")
          error.className = "text-xs text-red-500 mt-1 wizard-error"
          error.textContent = t('javascript.controllers.wizard_controller.this_field_is_required')
          input.parentNode.insertBefore(error, input.nextSibling)
        }
      } else {
        input.classList.remove("border-red-500")
        if (input.nextElementSibling?.classList.contains("wizard-error")) {
          input.nextElementSibling.remove()
        }
      }
    })

    return isValid
  }
}
